module.exports = __webpack_public_path__ + "static/media/GoldTDbutton.64c5164a.png";